// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyJobs_wrapperButton__LwlN9 .MyJobs_file_block__C55UF {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/views/myJobs/MyJobs.module.scss"],"names":[],"mappings":"AACE;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ","sourcesContent":[".wrapperButton {\n  .file_block {\n    // border: 1px solid;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperButton": `MyJobs_wrapperButton__LwlN9`,
	"file_block": `MyJobs_file_block__C55UF`
};
export default ___CSS_LOADER_EXPORT___;
